<template>
    <div class="new_action_data_section">
        <div v-if="actionType === 'story'">
            <h4>Choix du style de story</h4>
            <v-select v-model="storyStyleSelect" :hint="storyStyleSelect.desc ? storyStyleSelect.desc: ''"
                      :items="storyStyles" item-text="state" item-value="desc" label="Select" persistent-hint
                      return-object solo @change="storyEmitVerification" />
        </div>
        <div v-else-if="actionType === 'redirection'">
            <h4>Redirection</h4>
            <v-text-field v-model="redirectionUrl" :rules="[redirectionValidatorUrl]" label="URL"
                          placeholder="Entrez l'url de redirection" solo />
        </div>
        <div v-else>
            Aucune donnée de base nécessaire, appuyer sur continuez afin de créer votre contenu.
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import { storyStyle } from '../../actions/actionsList/story/storyStyle';

    export default {
        name: 'InitActionsData',
        props: {
            actionType: {
                type: String,
                default: ''
            }
        },
        data: () => ({
            storyStyles: [{ state: '', desc: '' }],
            storyStyleSelect: { state: '', desc: '' },
            redirectionUrl: '',
            redirectionValidatorUrl: value => {
                const pattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
                return (pattern.test(value) || value === '') || 'Invalid URL.';
            },
            assignCallbackInit: [],
            data: {}
        }),
        computed: {
            ...mapGetters('actions/story', ['defaultStory']),
            ...mapGetters('actions/redirection', ['defaultRedirection']),
            ...mapGetters('actions/ra3d', ['defaultRa3d']),
            ...mapGetters('actions/raDom', ['defaultRaDom']),
            ...mapGetters('actions/viewer3d', ['defaultViewer3d']),
            ...mapGetters('actions/content360', ['defaultContent360'])
        },
        watch: {
            redirectionUrl: function (newValue) {
                this.redirectionEmitVerification(newValue);
            },
            actionType: function (newValue) {
                let result = this.assignCallbackInit.filter((elem) => elem.type === newValue);
                if (result.length === 1) {
                    result[0].callback();
                }
            }
        },
        mounted () {
            this.assignCallbackInit = [
                { type: 'story', callback: this.storyInit },
                { type: 'redirection', callback: this.redirectionInit },
                { type: 'ra3d', callback: this.ra3dInit },
                { type: 'raDom', callback: this.raDomInit },
                { type: 'viewer3d', callback: this.viewer3dInit },
                { type: 'content360', callback: this.content360Init }
            ];
        },
        methods: {
            ...mapActions('actions/story', ['getStoryTypes']),
            storyInit: function () {
                this.getStoryTypes().then((data) => {
                    this.storyStyles = storyStyle.filter((x) => data.includes(x.state));
                });
                this.data = { ...this.defaultStory };
                this.$emit('verificationValues', { state: false, data: this.data });
            },
            storyEmitVerification: function (event) {
                this.data.templateType = event.state;
                this.$emit('verificationValues', { state: true, data: this.data });
            },
            redirectionInit: function () {
                this.data = { ...this.defaultRedirection };
                this.$emit('verificationValues', { state: true, data: this.data });
            },
            redirectionEmitVerification: function (newValue) {
                let state = this.redirectionValidatorUrl(newValue);
                this.data = { ...this.defaultRedirection };
                this.data.url = newValue;
                this.$emit('verificationValues', { state: state, data: this.data });
            },
            ra3dInit: function () {
                this.data = { ...this.defaultRa3d };
                this.$emit('verificationValues', { state: true, data: this.data });
            },
            raDomInit: function () {
                this.data = { ...this.defaultRaDom };
                this.$emit('verificationValues', { state: true, data: this.data });
            },
            viewer3dInit: function () {
                this.data = { ...this.defaultViewer3d };
                this.$emit('verificationValues', { state: true, data: this.data });
            },
            content360Init: function () {
                this.data = { ...this.defaultContent360 };
                this.$emit('verificationValues', { state: true, data: this.data });
            }
        }
    };
</script>

<style scoped>

</style>
